<template>
  <v-container fluid fill-height>
    <v-layout justify-center>
      <v-flex xs12 sm8>
        <v-card class="elevation-12 default-border">
          <v-card-title class="blue-grey white--text">
            <span class="title"
              >Negociação de
              {{ cadastroModel.nome ? cadastroModel.nome : "vazio" }}</span
            >
            <v-spacer></v-spacer>
            <v-icon
              color="white"
              @click="goEdit(cipherComputed.encrypt(cadastroModel.idPessoa))"
              >edit</v-icon
            >
            <v-icon
              color="white"
              @click="
                verDocumentos(cipherComputed.encrypt(cadastroModel.idPessoa))
              "
              >system_update_alt</v-icon
            >
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs4>
                <p>
                  <b>CPF:</b>
                  {{
                    cadastroModel.cpf
                      ? customFormatComputed.formatCnpjCpf(cadastroModel.cpf)
                      : "vazio"
                  }}
                </p>
              </v-flex>
              <v-flex xs4>
                <p>
                  <b>WhatsApp:</b>
                  {{ cadastroModel.whatapp ? cadastroModel.whatapp : "vazio" }}
                  <v-icon
                    color="primary"
                    @click="
                      linkWhatsapp(cadastroModel.nome, cadastroModel.whatapp)
                    "
                    :disabled="cadastroModel.whatapp == null"
                    >fab fa-whatsapp</v-icon
                  >
                </p>
              </v-flex>
              <v-flex xs4>
                <p>
                  <b>Telefone:</b>
                  {{
                    cadastroModel.telefone ? cadastroModel.telefone : "vazio"
                  }}
                </p>
              </v-flex>
              <v-flex xs4>
                <p>
                  <b>Origem:</b>
                  {{
                    cadastroModel.tipoOrigem
                      ? cadastroModel.tipoOrigem.nome
                      : "vazio"
                  }}
                </p>
              </v-flex>
              <v-flex xs4>
                <p>
                  <b>Status da Negociacao:</b>
                  {{
                    cadastroModel.tipoStatusNegociacao
                      ? cadastroModel.tipoStatusNegociacao.nome
                      : "vazio"
                  }}
                </p>
              </v-flex>
              <v-flex xs4>
                <p>
                  <b>Cidade-UF:</b>
                  {{
                    cadastroModel.geoCidade
                      ? cadastroModel.geoCidade.nome +
                        "-" +
                        cadastroModel.geoCidade.geoEstado.sigla
                      : "vazio"
                  }}
                </p>
              </v-flex>
              <v-flex xs4>
                <p>
                  <b>Email:</b>
                  {{ cadastroModel.email ? cadastroModel.email : "vazio" }}
                </p>
              </v-flex>
              <v-flex xs4>
                <p>
                  <b>Usuário:</b>
                  {{
                    cadastroModel.usuario ? cadastroModel.usuario.nome : "vazio"
                  }}
                </p>
              </v-flex>
              <v-flex xs4>
                <p>
                  <b>Data Inclusão:</b>
                  {{
                    cadastroModel.dataIncluso
                      ? customFormatComputed.toLocaleDateTimeString(
                          cadastroModel.dataIncluso
                        )
                      : "vazio"
                  }}
                </p>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card class="elevation-12 default-border">
          <v-card-title class="blue-grey white--text">
            <span class="title">Agendas</span>
          </v-card-title>
          <v-card-text class="py-0">
            <v-layout align-center>
              <v-spacer></v-spacer>
              <v-flex xs1 text-xs-right>
                <v-icon color="secondary" @click="agendar(cadastroModel)"
                  >event</v-icon
                >
              </v-flex>
            </v-layout>
            <v-data-table
              :headers="headers"
              :items="listaModeloAgendas"
              class="elevation-1"
              :pagination.sync="pagination"
            >
              <template v-slot:items="props">
                <td>{{ props.item.tipoCompromisso }}</td>
                <td>{{ props.item.usuarioR }}</td>
                <td>
                  {{
                    customFormatComputed.toLocaleDateTimeString(props.item.data)
                  }}
                </td>
                <td>{{ props.item.duracao }}</td>
                <td>{{ props.item.titulo }}</td>
                <td>{{ props.item.ativo ? "Sim" : "Não" }}</td>
                <td class="text-xs-center">
                  <v-icon @click="goEdit(props.item.idAgenda)" :disabled="true"
                    >edit</v-icon
                  >
                </td>
              </template>
            </v-data-table>
            <v-flex xs10>
              <span class="primary--text"
                >Quantidade total de agendas:
                {{ listaModeloAgendas.length }}</span
              >
            </v-flex>
          </v-card-text>
        </v-card>
        <v-card class="elevation-12 default-border">
          <v-card-title class="blue-grey white--text">
            <span class="title">Cadastrar Nota</span>
          </v-card-title>
          <v-card-text class="py-0">
            <v-form
              v-model="formularioCadastroValido"
              ref="formularioCadastroRef"
            >
              <v-flex xs12>
                <v-radio-group
                  v-model="
                    cadastroNotaModel.tipoNotaNegocicao.idTipoNotaNegocicao
                  "
                  row
                >
                  <v-radio label="Texto" value="1"></v-radio>
                  <v-radio label="Telefone" value="2"></v-radio>
                  <v-radio label="Consulta" value="7"></v-radio>
                  <v-radio label="WhatsApp" value="4"></v-radio>
                  <v-radio label="Reunião" value="5"></v-radio>
                  <v-radio label="Negociação" value="6"></v-radio>
                  <v-radio label="Email" value="3"></v-radio>                  
                </v-radio-group>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  v-model="cadastroNotaModel.texto"
                  color="secondary"
                  label="Observação"
                  :rules="regras.branco"
                  type="text"
                  required
                ></v-textarea>
              </v-flex>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              id="finalizar"
              color="primary"
              class="default-border"
              depressed
              @click="finalizarNota"
              :disabled="disableBtnFinalizar || !formValid"
              >Finalizar</v-btn
            >
          </v-card-actions>
        </v-card>
        <v-card class="elevation-12 default-border">
          <v-card-title class="blue-grey white--text">
            <span class="title">Histórico</span>
          </v-card-title>
          <v-card-text class="py-0">
            <v-timeline dense>
              <v-slide-x-reverse-transition group hide-on-leave>
                <v-timeline-item
                  v-for="item in listaStatusNeg"
                  :key="item.idPessoaStatusNegocicao"
                  :color="item.color"
                  small
                  fill-dot
                >
                  <v-alert :value="true" color="info" icon="info">
                    <b>Tipo de nota:</b>
                    {{ item.tipoNotaNegocicao.nome }}
                    <br />
                    <b>Nota:</b>
                    <br />
                    {{ item.texto }}
                    <br />
                    <b>Usuário:</b>
                    {{ item.usuario.nome }} -
                    <b>data inclusão:</b>
                    {{
                      customFormatComputed.toLocaleDateTimeString(
                        item.dataIncluso
                      )
                    }}
                  </v-alert>
                </v-timeline-item>
              </v-slide-x-reverse-transition>
            </v-timeline>
          </v-card-text>
        </v-card>
        <v-dialog v-model="dialog" max-width="900px" @mousedown="close()">
          <v-card>
            <v-card-title class="pt-0">
              <span class="headline pb-0"
                >Agendar Compromiso para
                {{
                  cadastroModel.nome == null ? "n/d" : cadastroModel.nome
                }}</span
              >
            </v-card-title>
            <v-card-text class="pt-0">
              <v-form
                v-model="modalFormularioCadastroValido"
                ref="modalFormularioCadastroRef"
              >
                <v-container grid-list-md class="pa-0">
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 md12>
                        <v-text-field
                          v-model="modeloAgenda.titulo"
                          color="secondary"
                          prepend-icon="chrome_reader_mode"
                          label="Titulo"
                          :rules="regras.branco50"
                          riquired
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md3>
                        <v-menu
                          ref="menuCalendarDataAgenda"
                          :close-on-content-click="false"
                          v-model="menuCalendarDataAgenda"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                          :return-value.sync="modeloAgenda.data"
                        >
                          <v-text-field
                            slot="activator"
                            v-model="dataAgendaFormatada"
                            label="Data"
                            prepend-icon="event"
                            readonly
                          ></v-text-field>
                          <v-date-picker
                            ref="picker"
                            v-model="modeloAgenda.data"
                            locale="pt-br"
                            :rules="regras.branco"
                            required
                            @input="
                              $refs.menuCalendarDataAgenda.save(
                                modeloAgenda.data
                              )
                            "
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex xs12 md3>
                        <v-dialog
                          ref="dialog"
                          v-model="modalHora"
                          :return-value.sync="modeloAgenda.hora"
                          persistent
                          lazy
                          full-width
                          width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="modeloAgenda.hora"
                              label="Hora"
                              prepend-icon="access_time"
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-time-picker
                            v-if="modalHora"
                            v-model="modeloAgenda.hora"
                            full-width
                            :landscape="false"
                            format="24hr"
                            min="07:30"
                            max="19:00"
                            riquired
                            :rules="regras.branco"
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              flat
                              color="primary"
                              @click="modalHora = false"
                              >Cancel</v-btn
                            >
                            <v-btn
                              flat
                              color="primary"
                              @click="$refs.dialog.save(modeloAgenda.hora)"
                              >OK</v-btn
                            >
                          </v-time-picker>
                        </v-dialog>
                      </v-flex>
                      <v-flex xs12 md2>
                        <v-text-field
                          v-model="modeloAgenda.duracao"
                          color="secondary"
                          prepend-icon="chrome_reader_mode"
                          label="Duração em min."
                          type="number"
                          :rules="regras.branco"
                          riquired
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md3>
                        <v-switch
                          :label="`${modeloAgenda.ativo ? 'Ativo' : 'Inativo'}`"
                          v-model="modeloAgenda.ativo"
                          color="primary"
                        ></v-switch>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-select
                          v-model="modeloAgenda.usuarioResponsavel"
                          color="secondary"
                          :items="listaUsuarios"
                          :rules="regras.branco"
                          item-text="nome"
                          prepend-icon="business_center"
                          label="Usuário Responsável"
                          return-object
                          riquired
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-select
                          v-model="modeloAgenda.tipoCompromisso"
                          color="secondary"
                          :items="listaTipoCompromisso"
                          :rules="regras.branco"
                          item-text="nome"
                          prepend-icon="business_center"
                          label="Compromisso"
                          return-object
                          riquired
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 md12>
                        <v-textarea
                          v-model="modeloAgenda.texto"
                          color="secondary"
                          label="Descrição"
                          type="text"
                        ></v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      id="fechar"
                      color="primary"
                      class="grey--text text--darken-1"
                      @click="close"
                      flat
                      >Fechar</v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                      id="finalizar"
                      color="primary"
                      class="default-border"
                      depressed
                      :disabled="modalDisableBtnFinalizar || !modalFormValid"
                      @click="finalizar"
                      >Finalizar</v-btn
                    >
                  </v-card-actions>
                </v-container>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
    <v-snackbar
      :timeout="5000"
      :color="`${snackbarModel.sucesso ? 'success' : 'error'}`"
      bottom
      multi-line
      v-model="snackbarModel.mostrar"
    >
      {{ snackbarModel.text }}
      <v-btn
        flat
        dark
        @click.native="
          `${
            snackbarModel.sucesso
              ? go('Pessoas')
              : (snackbarModel.mostrar = false)
          }`
        "
        >Fechar</v-btn
      >
    </v-snackbar>
  </v-container>
</template>

<script>
const COLORS = ["info", "warning", "error", "success"];
const ICONS = {
  info: "mdi-information",
  warning: "mdi-alert",
  error: "mdi-alert-circle",
  success: "mdi-check-circle",
};

import cipher from "@/helpers/cipher.js";
import customFormat from "@/helpers/custom-format.js";
import jwt from "@/helpers/jwt";

export default {
  name: "StatusPessoa",
  data: () => ({
    formularioCadastroValido: false,
    disableBtnFinalizar: false,
    modalFormularioCadastroValido: false,
    modalDisableBtnFinalizar: false,
    snackbarModel: {
      mostrar: false,
      text: "",
      sucesso: false,
    },
    cadastroModel: {
      idPessoa: null,
      nome: null,
      cpf: null,
      whatapp: null,
      celular: null,
      telefone: null,
      tipoOrigem: null,
      endereco: null,
      complemento: null,
      cep: null,
      geoCidade: null,
      bairro: null,
      email: null,
      usuario: null,
      contaCriador: null,
      dataIncluso: null,
    },
    cadastroNotaModel: {
      tipoNotaNegocicao: { idTipoNotaNegocicao: "1" },
      texto: null,
      pessoa: { idPessoa: null },
      usuario: {
        idUsuario: jwt.decryptToken().id,
      },
    },
    listaStatusNeg: [],
    pagination: { sortBy: "data", descending: true, rowsPerPage: 5 },
    headers: [
      { text: "Tipo Compromisso", value: "tipoCompromisso" },
      { text: "Responsável", value: "usuarioR" },
      { text: "Data", value: "data" },
      { text: "Duração", value: "duracao" },
      { text: "Titulo", value: "titulo" },
      { text: "Ativo?", value: "ativo" },
      { text: "Ações", value: "", sortable: false, align: "center" },
    ],
    modelo: {
      idAgenda: null,
      data: null,
      usuarioR: null,
      whatapp: null,
      titulo: null,
      nome: null,
      duracao: null,
      ativo: null,
      dataIncluso: null,
      tipoCompromisso: null,
    },
    listaModeloAgendas: [],
    modeloAgenda: {
      pessoa: { idPessoa: null },
      tipoCompromisso: null,
      data: null,
      hora: null,
      duracao: 30,
      titulo: "",
      texto: null,
      usuarioCriador: {
        idUsuario: jwt.decryptToken().id,
      },
      usuarioResponsavel: null,
      conta: {
        idConta: jwt.decryptToken().idconta,
      },
      ativo: true,
    },
    dialog: false,
    listaUsuarios: [],
    menuCalendarDataAgenda: false,
    dataAgendaFormatada: null,
    modalHora: false,
    listaTipoCompromisso: [],
    // items: [
    //   {
    //     id: 1,
    //     color: "info",
    //     icon: ICONS["info"],
    //   },
    //   {
    //     id: 2,
    //     color: "warning",
    //     icon: ICONS["warning"],
    //   },
    //   {
    //     id: 3,
    //     color: "error",
    //     icon: ICONS["error"],
    //   },
    //   {
    //     id: 4,
    //     color: "success",
    //     icon: ICONS["success"],
    //   },
    // ],
    regras: {
      branco: [(v) => !!v || "Você não pode deixar este campo em branco"],
    },
  }),
  computed: {
    customFormatComputed: function () {
      return customFormat;
    },
    cipherComputed: function () {
      return cipher;
    },
    formValid: function () {
      return this.formularioCadastroValido;
    },
    modalFormValid: function () {
      return this.modalFormularioCadastroValido;
    },
  },
  watch: {
    dialog(val) {
      const self = this;
      if (!val) {
        self.close();
      }
    },
    "modeloAgenda.data": function (val) {
      this.dataAgendaFormatada = val
        ? new Date(val).toLocaleDateString("pt-br", { timeZone: "UTC" })
        : "";
    },
  },
  mounted: function () {
    this.buscarPessoa();
    this.buscarUsuario();
    this.buscarTipoCompro();
  },
  methods: {
    finalizarNota: function () {
      const self = this;
      self.$store.commit("startLoading");
      if (self.$refs.formularioCadastroRef.validate()) {
        const item = jwt.decryptToken();
        if (item != null) {
          self.cadastroNotaModel.pessoa.idPessoa = self.cadastroModel.idPessoa;
          self.$http
            .post(
              `${process.env.URL_API}/pessoa/v1/status/cadastro`,
              self.cadastroNotaModel,
              {
                headers: {
                  Authorization:
                    "Bearer " + JSON.parse(localStorage.getItem("token")),
                },
              }
            )
            .then(function (response) {
              const data = response.data;
              if (data.sucesso) {
                //self.disableBtnFinalizar = data.sucesso;
                self.snackbarText = data.mensagem;
                self.snackbarMostrar = true;
                self.snackbarSucesso = data.sucesso;
                self.cadastroNotaModel.texto = null;
                self.buscarStatusEmpresa();
              } else {
                self.snackbarModel.text = data.mensagem;
                self.snackbarModel.mostrar = true;
                self.snackbarModel.sucesso = data.sucesso;
                self.disableBtnFinalizar = data.sucesso;
              }
            })
            .catch(function (error) {
              self.snackbarModel.text = error.response.data.message;
              self.snackbarModel.sucesso = false;
              self.snackbarModel.mostrar = true;
              self.disableBtnFinalizar = false;
            });
        } else {
          self.go("Login");
        }
      }
      self.$store.commit("endLoading");
    },
    finalizar: function () {

      const self = this;
      self.$store.commit("startLoading");
      if (self.$refs.modalFormularioCadastroRef.validate()) {
        const item = jwt.decryptToken();
        if (item != null) {
          self.$http
            .post(
              `${process.env.URL_API}/agenda/v1/cadastro`,
              self.modeloAgenda,
              {
                headers: {
                  Authorization:
                    "Bearer " + JSON.parse(localStorage.getItem("token")),
                },
              }
            )
            .then(function (response) {
              const data = response.data;
              if (data.sucesso) {
                self.disableBtnFinalizar = data.sucesso;
                self.close();

                self.snackbarText = data.mensagem;
                self.snackbarMostrar = true;
                self.snackbarSucesso = data.sucesso;
                self.buscarStatusEmpresa();
                self.buscarAgendas();
              } else {
                self.snackbarModel.text = data.mensagem;
                self.snackbarModel.mostrar = true;
                self.snackbarModel.sucesso = data.sucesso;
                self.disableBtnFinalizar = data.sucesso;
              }
            })
            .catch(function (error) {
              self.snackbarModel.text = error.response.data.message;
              self.snackbarModel.sucesso = false;
              self.snackbarModel.mostrar = true;
              self.disableBtnFinalizar = false;
            });
        } else {
          self.go("Login");
        }
      }
      self.$store.commit("endLoading");
    },
    buscarPessoa: function () {
      const self = this;
      const item = jwt.decryptToken();
      if (item != null) {
        if (
          this.$route.params.id &&
          Number.isInteger(parseInt(cipher.decrypt(this.$route.params.id)))
        ) {
          self.$http
            .get(
              `${process.env.URL_API}/pessoa/v1/busca/conta/` +
                jwt.decryptToken().idconta +
                `/` +
                cipher.decrypt(this.$route.params.id),
              {
                headers: {
                  Authorization:
                    "Bearer " + JSON.parse(localStorage.getItem("token")),
                },
              }
            )
            .then(function (response) {
              const resposta = response.data[0];
              self.cadastroModel.idPessoa = resposta.idPessoa;
              self.cadastroModel.nome = resposta.nome;
              self.cadastroModel.cnpj = resposta.cnpj;
              self.cadastroModel.dividaEstadual = resposta.dividaEstadual;
              self.cadastroModel.dividaFederal = resposta.dividaFederal;
              self.cadastroModel.whatapp = resposta.whatapp;
              self.cadastroModel.celular = resposta.celular;
              self.cadastroModel.telefone = resposta.telefone;
              self.cadastroModel.tipoOrigem = resposta.tipoOrigem;
              self.cadastroModel.tipoSegmento = resposta.tipoSegmento;
              self.cadastroModel.tipoStatusNegociacao =
                resposta.tipoStatusNegociacao;
              self.cadastroModel.endereco = resposta.endereco;
              self.cadastroModel.complemento = resposta.complemento;
              self.cadastroModel.cep = resposta.cep;

              self.cadastroModel.bairro = resposta.bairro;
              self.cadastroModel.email = resposta.email;
              self.cadastroModel.site = resposta.site;
              self.cadastroModel.usuario = resposta.usuario;
              self.cadastroModel.contaCriador = resposta.contaCriador;
              self.cadastroModel.dataIncluso = resposta.dataIncluso;

              if (resposta.geoCidade != null) {
                self.cadastroModel.geoCidade = resposta.geoCidade;
              }
              self.buscarStatusEmpresa();
              self.buscarAgendas();
            });
        } else {
          self.go("Pessoas");
        }
      }
    },
    verDocumentos(id) {
      const self = this;
      self.$router.push({ name: "DocumentosPessoa", params: { id: id } });
    },
    buscarStatusEmpresa: function () {
      const self = this;
      const item = jwt.decryptToken();
      if (item != null) {
        self.$http
          .get(
            `${process.env.URL_API}/pessoa/v1/status/busca/` +
              self.cadastroModel.idPessoa,
            {
              headers: {
                Authorization:
                  "Bearer " + JSON.parse(localStorage.getItem("token")),
              },
            }
          )
          .then(function (response) {
            self.listaStatusNeg = [];
            self.listaStatusNeg = response.data;
            self.listaStatusNeg.sort(function (a, b) {
              return new Date(b.dataIncluso) - new Date(a.dataIncluso);
            });
          });
      }
    },
    buscarAgendas: function () {
      const self = this;
      const item = jwt.decryptToken();
      if (item != null) {
        self.$http
          .get(
            `${process.env.URL_API}/agenda/v1/busca/pessoa/` +
              self.cadastroModel.idPessoa,
            {
              headers: {
                Authorization:
                  "Bearer " + JSON.parse(localStorage.getItem("token")),
              },
            }
          )
          .then(function (response) {
            self.listaModeloAgendas = [];
            self.bindLista(response.data);
          });
      } else {
        self.go("Login");
      }
    },
    linkWhatsapp: function (nome, telefone) {
      const self = this;
      window.open(
        "https://api.whatsapp.com/send?phone=+55" +
          telefone +
          "&text=Olá%20" +
          nome
      );
    },
    buscarUsuario: function () {
      const self = this;
      const item = jwt.decryptToken();
      if (item != null) {
        self.$http
          .get(
            `${process.env.URL_API}/usuario/v1/busca/nome/conta/ativas/` +
              jwt.decryptToken().idconta,
            {
              headers: {
                Authorization:
                  "Bearer " + JSON.parse(localStorage.getItem("token")),
              },
            }
          )
          .then(function (response) {
            self.listaUsuarios = response.data;
            self.listaUsuarios.sort(self.nome);
          });
      } else {
        self.go("Login");
      }
    },
    buscarTipoCompro: function () {
      const self = this;
      const item = jwt.decryptToken();
      if (item != null) {
        self.$http
          .get(`${process.env.URL_API}/tipocompromisso/v1/busca/`, {
            headers: {
              Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("token")),
            },
          })
          .then(function (response) {
            self.listaTipoCompromisso = response.data;
            self.listaTipoCompromisso.sort(self.nome);
          });
      } else {
        self.go("Login");
      }
    },
    bindLista: function (lista) {
      for (var i = 0, len = lista.length; i < len; ++i) {
        let add = Object.create(this.modelo, {
          idAgenda: { value: lista[i].idAgenda },
          nome: {
            value: lista[i].pessoa
              ? lista[i].pessoa.nome
              : lista[i].empresa.nome,
          },
          whatapp: {
            value: lista[i].pessoa
              ? lista[i].pessoa.whatapp
              : lista[i].empresa.whatapp,
          },
          titulo: { value: lista[i].titulo },
          usuarioR: { value: lista[i].usuarioResponsavel.nome },
          data: { value: lista[i].data + "T" + lista[i].hora + ":00" },
          duracao: { value: lista[i].duracao },
          ativo: { value: lista[i].ativo },
          dataIncluso: { value: lista[i].dataIncluso },
          tipoCompromisso: { value: lista[i].tipoCompromisso.nome },
        });

        this.listaModeloAgendas.push(add);
      }
    },
    agendar: function (pessoa) {
      const self = this;

      self.modeloAgenda.pessoa.idPessoa = pessoa.idPessoa;

      self.dialog = true;
    },
    close() {
      const self = this;

      self.modeloAgenda.pessoa.idPessoa = null;
      self.modeloAgenda.data = null;
      self.modeloAgenda.hora = null;
      self.modeloAgenda.duracao = 30;
      self.modeloAgenda.texto = null;

      self.dialog = false;
    },
    go: function (routeName, routeParams) {
      const self = this;
      if (this.$router.currentRoute.name != routeName) {
        if (!routeParams) {
          self.$router.push({ name: routeName });
        } else {
          self.$router.push({ name: routeName, params: routeParams });
        }
      }
    },
    goEdit: function (id) {
      const self = this;
      self.$router.push({ name: "CadastroPessoa", params: { id: id } });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/clientes/StatusPessoa.vue